import React, { useState, useEffect } from "react";

const AdminUser = ({
  id_R,
  closeAdminUserModal,
  adminUserModalOpen,
  selectedUser,
  openUsernameModal,
  openContaInfoModal,
  openTwoFactorAuthModal,
  openSignInModal,
  openEditRolesModal,
  openUserResetPassword,
}) => {
  const [activeTab, setActiveTab] = useState("tab1");

  const handleUsernameClick = () => {
    // Open the next modal
    openUsernameModal();
  };

  const handleContaInfoClick = () => {
    // Open the next modal
    openContaInfoModal();
  };
  const handleTwoFactorAuthClick = () => {
    // Open the next modal
    openTwoFactorAuthModal();
  };
  const handleSignInClick = () => {
    // Open the next modal
    openSignInModal();
  };

  const handleEditRolesClick = () => {
    // Open the next modal
    openEditRolesModal();
  };

  return (
    <>
      <div
        id={id_R}
        className={`${
          adminUserModalOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow max-w-[100%] mx-auto h-[95vh]">
            <div className="justify-end rounded-t flex items-end">
              <button
                onClick={closeAdminUserModal}
                type="button"
                className="bg-transparent rounded-lg text-sm p-2.5 ml-auto inline-flex items-center"
                data-modal-toggle={id_R}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.84 12L5.7 8.9L3.9 12H0.2L3.88 6.3L0.1 0.839999H3.94L6.08 3.92L7.88 0.839999H11.58L7.84 6.46L11.68 12H7.84Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>
            <div className="flex items-center w-[58vw]">
              <div className="w-[10vw] flex items-center justify-center">
                <div className="w-[97px] h-[97px] rounded-full bg-[#8ED6A8] flex items-center justify-center text-[#06B217] text-[36px] font-medium">
                  {selectedUser?.firstname
                    ?.charAt(0)
                    .toUpperCase()
                    ?.slice(0, 1)}
                  {selectedUser?.lastname?.charAt(0).toUpperCase()?.slice(0, 1)}
                </div>
              </div>
              <div className="w-[30vw]">
                <p className="text-[#000] text-[20px] bold">
                  {selectedUser?.firstname?.charAt(0)?.toUpperCase() +
                    selectedUser?.firstname?.slice(1)?.toLowerCase()}{" "}
                  {selectedUser?.lastname?.charAt(0)?.toUpperCase() +
                    selectedUser?.lastname?.slice(1)?.toLowerCase()}
                </p>
                <p className="text-[#005C53] text-[15px] font-normal">
                  {selectedUser?.public_id}
                </p>
                <div className="w-[35vw] flex">
                  <div
                    onClick={openUserResetPassword}
                    className="flex items-center gap-2 w-[20vw] cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_6583_1704)">
                        <path
                          d="M16.667 11.3333V9.99999C16.667 9.64637 16.5265 9.30723 16.2765 9.05718C16.0264 8.80713 15.6873 8.66666 15.3337 8.66666H2.00033C1.6467 8.66666 1.30756 8.80713 1.05752 9.05718C0.807468 9.30723 0.666992 9.64637 0.666992 9.99999V18C0.666992 18.3536 0.807468 18.6927 1.05752 18.9428C1.30756 19.1928 1.6467 19.3333 2.00033 19.3333H15.3337C15.6873 19.3333 16.0264 19.1928 16.2765 18.9428C16.5265 18.6927 16.667 18.3536 16.667 18V16.6667M16.667 11.3333H11.3337C10.6264 11.3333 9.94814 11.6143 9.44804 12.1144C8.94794 12.6145 8.66699 13.2927 8.66699 14C8.66699 14.7072 8.94794 15.3855 9.44804 15.8856C9.94814 16.3857 10.6264 16.6667 11.3337 16.6667H16.667M16.667 11.3333C17.3742 11.3333 18.0525 11.6143 18.5526 12.1144C19.0527 12.6145 19.3337 13.2927 19.3337 14C19.3337 14.7072 19.0527 15.3855 18.5526 15.8856C18.0525 16.3857 17.3742 16.6667 16.667 16.6667M4.66699 8.66666V4.66666C4.66699 3.60579 5.08842 2.58837 5.83856 1.83823C6.58871 1.08808 7.60613 0.666656 8.66699 0.666656C9.72786 0.666656 10.7453 1.08808 11.4954 1.83823C12.2456 2.58837 12.667 3.60579 12.667 4.66666V8.66666M16.0003 14H17.3337M13.3337 14H14.667M10.667 14H12.0003"
                          stroke="#06B217"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6583_1704">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p className="text-[#000] text-[14px] font-normal">
                      Reset password
                    </p>
                  </div>
                  <div className="flex items-center justify-center gap-2 w-[20vw]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <path
                        d="M10.5 18.5C14.9183 18.5 18.5 14.9183 18.5 10.5C18.5 6.08172 14.9183 2.5 10.5 2.5C6.08172 2.5 2.5 6.08172 2.5 10.5C2.5 14.9183 6.08172 18.5 10.5 18.5Z"
                        stroke="#06B217"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16 5L5 16"
                        stroke="#06B217"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p className="text-[#000] text-[14px] font-normal">
                      Suspend
                    </p>
                  </div>
                  <div className="flex items-center justify-center gap-2 w-[20vw]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_6583_1706)">
                        <path
                          d="M10.596 0C13.822 0 16.438 2.566 16.438 5.732C16.4372 6.56421 16.2534 7.38607 15.8997 8.13935C15.546 8.89264 15.0309 9.55892 14.391 10.091C14.665 10.224 14.914 10.358 15.139 10.493C15.624 10.783 16.127 11.143 16.649 11.572C16.7194 11.6291 16.7777 11.6998 16.8204 11.7798C16.8631 11.8598 16.8893 11.9476 16.8975 12.0379C16.9057 12.1283 16.8957 12.2193 16.8681 12.3057C16.8406 12.3921 16.796 12.4721 16.737 12.541C16.6161 12.6814 16.4451 12.769 16.2605 12.7851C16.0759 12.8012 15.8923 12.7444 15.749 12.627C15.3265 12.2745 14.8786 11.9536 14.409 11.667C13.9509 11.4005 13.4751 11.1656 12.985 10.964C12.2318 11.2952 11.4178 11.4655 10.595 11.464C9.68846 11.4656 8.79372 11.2586 7.97999 10.859L7.93799 10.879C5.96099 11.635 4.51799 12.753 3.58799 14.237C2.65299 15.726 2.27099 17.39 2.44199 19.251C2.44938 19.3418 2.43877 19.4331 2.41077 19.5198C2.38278 19.6064 2.33796 19.6867 2.27887 19.756C2.21978 19.8253 2.1476 19.8823 2.06645 19.9237C1.9853 19.965 1.89679 19.9899 1.80599 19.997C1.62255 20.0149 1.43949 19.9594 1.29688 19.8426C1.15426 19.7259 1.06369 19.5574 1.04499 19.374C0.847994 17.222 1.29799 15.261 2.39299 13.516C3.35699 11.98 4.77299 10.786 6.62299 9.935C6.03463 9.40421 5.56419 8.75588 5.24208 8.0319C4.91997 7.30792 4.75335 6.5244 4.75299 5.732C4.75299 2.566 7.36999 0 10.596 0ZM17.819 14.24C17.9491 14.1115 18.1245 14.0391 18.3074 14.0386C18.4903 14.038 18.6661 14.1093 18.797 14.237C19.067 14.503 19.067 14.935 18.799 15.202L17.607 16.381L18.799 17.561C18.863 17.624 18.9137 17.6991 18.9483 17.7819C18.9829 17.8647 19.0006 17.9537 19.0004 18.0434C19.0003 18.1332 18.9822 18.222 18.9472 18.3047C18.9123 18.3874 18.8612 18.4623 18.797 18.525C18.6664 18.653 18.4907 18.7246 18.3078 18.7244C18.1249 18.7242 17.9494 18.6523 17.819 18.524L16.632 17.347L15.445 18.524C15.3285 18.6385 15.1755 18.7085 15.0127 18.7219C14.8499 18.7352 14.6876 18.691 14.554 18.597L14.468 18.525C14.4038 18.4623 14.3527 18.3874 14.3178 18.3047C14.2828 18.222 14.2647 18.1332 14.2645 18.0434C14.2644 17.9537 14.2821 17.8647 14.3167 17.7819C14.3513 17.6991 14.402 17.624 14.466 17.561L15.656 16.381L14.466 15.201C14.402 15.138 14.3513 15.0629 14.3167 14.9801C14.2821 14.8973 14.2644 14.8083 14.2645 14.7186C14.2647 14.6288 14.2828 14.54 14.3178 14.4573C14.3527 14.3746 14.4038 14.2997 14.468 14.237C14.5987 14.1094 14.7742 14.0382 14.9569 14.0386C15.1396 14.0389 15.3148 14.1109 15.445 14.239L16.632 15.415L17.819 14.24ZM10.596 1.375C8.14299 1.375 6.15599 3.325 6.15599 5.731C6.15599 8.137 8.14299 10.088 10.596 10.088C13.048 10.088 15.036 8.138 15.036 5.731C15.036 3.325 13.048 1.375 10.596 1.375Z"
                          fill="#06B217"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6583_1706">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p className="text-[#000] text-[14px] font-normal">
                      Delete user
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-[25%] mx-[20px] h-[10vh] gap-4 flex items-end">
              <button
                className={`w-[50%] mt-1.5 h-[39px] ${
                  activeTab === "tab1" ? "font-medium" : ""
                }`}
                onClick={() => setActiveTab("tab1")}
              >
                <p
                  className={`text-[#000] text-[16px] ${
                    activeTab === "tab1" ? "font-medium" : ""
                  }`}
                >
                  Account
                </p>
                {activeTab === "tab1" && (
                  <div className="w-[100%] h-[4px] mt-3.5 bg-[#06B217]" />
                )}
              </button>
              <button
                className={`w-[50%] mt-1.5 h-[39px] ${
                  activeTab === "tab2" ? "font-medium" : ""
                }`}
                onClick={() => setActiveTab("tab2")}
              >
                <p
                  className={`text-[#000] text-[16px] ${
                    activeTab === "tab2" ? "font-medium" : ""
                  }`}
                >
                  Role
                </p>
                {activeTab === "tab2" && (
                  <div className="w-[100%] h-[4px] mt-3.5 bg-[#06B217]" />
                )}
              </button>
            </div>

            {activeTab === "tab1" && (
              <div>
                <div className="w-[95%] mx-[20px] h-[15vh] flex items-end  ">
                  <div className="w-[30vw]  ">
                    <p className="text-[#000] text-[16px] font-medium">
                      Username and email
                    </p>
                    <p className="mt-3 text-[#4F4F4F] text-[16px] font-[300]">
                      {selectedUser?.email}
                    </p>
                    <p
                      className="text-[#06B217] text-[15px] font-normal cursor-pointer"
                      onClick={() => {
                        handleUsernameClick();
                      }}
                    >
                      Manage username and email
                    </p>
                  </div>
                  <div className="w-[20vw]  ">
                    <p className="text-[#000] text-[16px] font-medium">
                      Sign out
                    </p>
                    <p className="mt-3 text-[#4F4F4F] text-[16px] font-[300]">
                      Sign out this user out of all sessions
                    </p>
                    <p className="text-[#06B217] text-[16px] font-normal cursor-pointer">
                      Sign out all sessions
                    </p>
                  </div>
                </div>
                <div className="w-[95%] mx-[20px] h-[15vh] flex items-end ">
                  <div className="w-[30vw]">
                    <p className="text-[#000] text-[16px] font-medium">
                      Security
                    </p>
                    <p
                      className="mt-3 text-[#06B217] text-[15px] font-[300] cursor-pointer"
                      onClick={() => {
                        handleSignInClick();
                      }}
                    >
                      View Last 7 days
                    </p>
                    <p
                      className="text-[#06B217] text-[15px] font-[300] cursor-pointer"
                      onClick={() => {
                        handleTwoFactorAuthClick();
                      }}
                    >
                      Manage Two-Factor authentication
                    </p>
                  </div>
                  <div className="w-[20vw]">
                    <p className="text-[#000] text-[16px] font-medium">Role</p>
                    <p className="text-[#4F4F4F] text-[16px] font-[300] mt-3">
                      {selectedUser?.role?.name}
                    </p>
                  </div>
                </div>

                <div className="w-[95%] mx-[20px] h-[10vh] flex items-end text-[#000] text-[16px] font-medium">
                  Contact information
                </div>
                <div className="w-[95%] h-[10vh] mx-[20px] flex items-center ">
                  <div className="w-[30vw] ">
                    <p className="text-[#000] text-[15px] font-medium">
                      First name
                    </p>
                    <p className="text-[#4F4F4F] text-[16px] font-[300]">
                      {selectedUser?.firstname}
                    </p>
                  </div>
                  <div className="w-[20vw]">
                    <p className="text-[#000] text-[15px] font-medium">
                      Last name
                    </p>
                    <p className="text-[#4F4F4F] text-[16px] font-[300]">
                      {selectedUser?.lastname}
                    </p>
                  </div>
                </div>
                <div className="w-[95%] h-[6vh] mx-[20px] flex items-center  ">
                  <div className="w-[30vw]  ">
                    <p className="text-[#000] text-[15px] font-medium">
                      Phone number
                    </p>
                    <p className="text-[#4F4F4F] text-[16px] font-[300]">
                      {selectedUser?.phone}
                    </p>
                  </div>
                </div>
                <div className="w-[95%] h-[6vh] mx-[20px] flex items-end ">
                  <div className="w-[30vw] ">
                    <p
                      className="text-[#06B217] text-[15px] font-normal cursor-pointer"
                      onClick={() => {
                        handleContaInfoClick();
                      }}
                    >
                      Manage Contact Information
                    </p>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "tab2" && (
              <div>
                <div className="w-[95%] mx-[20px] mt-6 flex  ">
                  <div className="w-[20vw]  ">
                    <p className="text-[#000] text-[16px] font-medium">Role</p>
                    <p className="mt-3 text-[#4F4F4F] text-[16px] font-[300]">
                      {selectedUser?.role?.name}
                    </p>
                    <p
                      className="text-[#06B217] text-[15px] font-normal cursor-pointer"
                      onClick={() => {
                        handleEditRolesClick();
                      }}
                    >
                      Manage role
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminUser;
